import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { ClassGroup, ClassGroupsRequest } from 'shared/api';
import type { ClassGroupsTableState } from './types';

export const initialClassGroupsTableState: ClassGroupsTableState = {
  request: {
    page: 0,
    size: 10,
    sort: [],
  },
  createVisible: false,
  generateVisible: false,
  deletingGroup: null,
  editingGroup: null,
  editName: '',
  editTeacherId: undefined,
};

export const classGroupsTableSlice = createSlice({
  name: 'classGroupsTable',
  initialState: initialClassGroupsTableState,
  reducers: {
    setRequest: (state, action: PayloadAction<ClassGroupsRequest>) => {
      state.request = action.payload;
    },
    setCreateVisible: (state, action: PayloadAction<boolean>) => {
      state.createVisible = action.payload;
    },
    setGenerateVisible: (state, action: PayloadAction<boolean>) => {
      state.generateVisible = action.payload;
    },
    setDeletingGroup: (state, action: PayloadAction<ClassGroup | null>) => {
      state.deletingGroup = action.payload;
    },
    startEdit: (state, action: PayloadAction<ClassGroup>) => {
      state.editingGroup = action.payload;
      state.editName = action.payload.name || '';
      state.editTeacherId = action.payload.teacherId || undefined;
    },
    cancelEdit: (state) => {
      state.editingGroup = null;
      state.editName = '';
      state.editTeacherId = undefined;
    },
    setEditName: (state, action: PayloadAction<string>) => {
      state.editName = action.payload;
    },
    setEditTeacherId: (state, action: PayloadAction<number | undefined>) => {
      state.editTeacherId = action.payload;
    },
    reset: () => initialClassGroupsTableState,
  },
});

export const { actions: classGroupsTableActions, reducer: classGroupsTableReducer } =
  classGroupsTableSlice;
